import React from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Modal
} from '@material-ui/core';
import { TFile } from '../../types/cloudStorage/CloudFileList';
import { useHistory } from 'react-router-dom';
import {
  ModalCancelButton,
  ModalDeleteButton
} from '../parts/cloudStorage/style/style';

type Tprops = {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  deleteFiles: TFile[];
  onDeleteFile: () => void;
};

export const DeleteModal: React.FC<Tprops> = (props: Tprops) => {
  const { modalOpen, setModalOpen, deleteFiles, onDeleteFile } = props;

  const classes = useStyles();
  const history = useHistory();

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div className={classes.modalHeader}>
            <h1 className={classes.modalTitle}>資料を削除</h1>
            <p>
              選択した書類を削除しますか？
              <br />
              ※この操作は取り消せません。
            </p>
          </div>
        </Grid>

        <div className={classes.body}>
          <Grid container justify={'center'}>
            <Grid item>
              <div className={classes.bodyListArea}>
                {deleteFiles.map((file: TFile) => {
                  return <p>{file.name}</p>;
                })}
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setModalOpen(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton variant='contained' onClick={() => onDeleteFile()}>
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: '1px solid #e6e6e6'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%'
    },

    modalHeader: {
      textAlign: 'center',
      '& > p': {
        color: '#ff1212'
      }
    },
    modalTitle: {
      fontWeight: 'bold',
      marginTop: 32,
      marginBottom: 20,
      fontSize: 16
    },
    // headerText: {
    //   fontSize: 20,
    //   marginTop: 10,
    //   marginBottom: 10
    // },

    body: {
      backgroundColor: theme.palette.background.paper,
      width: '100%'
    },
    bodyListArea: {
      maxHeight: '300px',
      width: '100%',
      padding: theme.spacing(5)
    },

    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
